import { Image, Text } from '@belong/ui';
import type { MaintenanceRecurrenceModel } from 'api/models';
import { startCase } from 'es-toolkit/compat';
import { RecurringProServicePrice } from 'maintenance/components/recurring-pro-service-price/recurring-pro-service-price';
import { RecurringProServiceStatusTag } from 'maintenance/components/recurring-pro-service-status-tag/recurring-pro-service-status-tag';
import type { RecurringProServiceStatus } from 'maintenance/types';
import styles from './recurring-pro-service-card.module.css';

type Props = {
  description: string;
  // Optional: the caller resolves it from a `.find` that can miss, and the
  // render below is already guarded by `{imageSrc && …}`.
  imageSrc?: string;
  isHomeownerView?: boolean;
  name: MaintenanceRecurrenceModel['recurringTask'];
  price?: string;
  status?: RecurringProServiceStatus;
};

export function RecurringProServiceCard({
  description,
  imageSrc,
  isHomeownerView = false,
  name,
  price,
  status = 'off',
}: Props) {
  return (
    <div className="flex flex-col rounded border border-solid border-gray sm:flex-row">
      <div className="relative">
        {!isHomeownerView && (
          <div className="absolute left-sm top-xs z-10">
            <RecurringProServiceStatusTag status={status} />
          </div>
        )}
        {price && (
          <div className="absolute bottom-xs left-sm z-10 sm:hidden">
            <RecurringProServicePrice price={price} />
          </div>
        )}
        <div className={styles.backdrop} />
        <div className={styles.image}>
          {imageSrc && (
            <Image
              alt={startCase(name)}
              className="rounded-t sm:rounded-l sm:rounded-tr-none"
              src={imageSrc}
            />
          )}
        </div>
      </div>
      <div className="p-sm">
        {price && (
          <div className="hidden sm:mb-xs sm:block">
            <RecurringProServicePrice price={price} />
          </div>
        )}
        <Text>{description}</Text>
      </div>
    </div>
  );
}
